import * as React from 'react';
import Layout from '@components/layout/Layout';
import Header from '@components/layout/Header';
import Navigation from '@components/layout/Navigation';
import { Outlet } from 'react-router-dom';
import { Announcement } from '@components/dialogs/Announcement';
import ConductorHeader from '@components/layout/ConductorHeader';
import { Typography } from '@mui/joy';

export default function LoggedInConductorLayout() {
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  return (<>
      {drawerOpen && (
        <Layout.SideDrawer onClose={() => setDrawerOpen(false)}>
          {/* <Navigation drawer={true} /> */}
        </Layout.SideDrawer>
      )}
      <Layout.Root
        sx={{
          ...(drawerOpen && {
            height: '100vh',
            overflow: 'hidden',
          }),
        }}
      >
        <Layout.Header>
          <ConductorHeader />
        </Layout.Header>
        <Layout.SideNav>
          <Typography
            fontSize={'lg'}
            letterSpacing={'0.1rem'}
            textTransform={'uppercase'}
            sx={{
              writingMode: 'vertical-rl',
              textOrientation: 'mixed',
              color: 'background.level3',
              width: 'calc(100% - 0.4rem)',
            }}
          >Conductor</Typography>
          {/* <Navigation drawer={false} /> */}
        </Layout.SideNav>
        <Layout.Main>
          <Outlet/>
        </Layout.Main>
      </Layout.Root>

      {/* <Announcement/> */}
  </>);
}
